import { Injectable } from '@angular/core'
import { ClientIPTreeNode } from '../../types/ClientIPListTree'

@Injectable({
  providedIn: 'root',
})
export class ClientIpListTreeNodesAdjustService {
  constructor() {}

  expandAllNodes(nodes: ClientIPTreeNode[]): ClientIPTreeNode[] {
    return nodes.map((node) => this.setNodeExpandedRecursively(node, true))
  }

  collapseAllNodes(nodes: ClientIPTreeNode[]): ClientIPTreeNode[] {
    return nodes.map((node) => this.setNodeExpandedRecursively(node, false))
  }

  private setNodeExpandedRecursively(node: ClientIPTreeNode, expanded: boolean): ClientIPTreeNode {
    const { children, ...rest } = node
    return {
      ...rest,
      expanded,
      children:
        children &&
        Array.isArray(children) &&
        children.map((child) => this.setNodeExpandedRecursively(child, expanded)),
    }
  }
}
